import React from 'react';
import { Button, Grid, ModalWindow, SwitchDialogWindows } from 'ui-toolkit';
import { IStandardDocumentVersionData } from '../../../../../types/order/documents/shared/interfaces';
import { useAppDispatch } from '../../../../../store/store';
import { UUID } from '../../../../../types/shared/UUID';
import { useParams } from 'react-router-dom';
import { useDeleteDocumentMutation } from '../../../../../API/order/documents/DocumentApi';
import { getAdminDocuments } from '../../../../../store/order/documents/adminDocuments/dispatch';
import { DeleteSuccessMessage } from './DeleteSuccessMessage';
import { DeleteErrorTitle } from './DeleteErrorTitle';
import { DeleteErrorMessage } from './DeleteErrorMessage';
import { BodyTextTW } from '../../../../../tailwindComponents/bodyText/BodyTextTW';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../../../API/documentCategories/DocumentCategoriesApi';

interface DeleteDocumentModalProps {
  onClose: () => void;
  document: IStandardDocumentVersionData;
}

export const DeleteDocumentModal: React.FC<DeleteDocumentModalProps> = ({
  onClose,
  document: { versionId, id: documentId },
}) => {
  const dispatch = useAppDispatch();
  const { orderId } = useParams<{ orderId: UUID }>();
  const { data: { allCategories } = defaultNormalizedDocumentCategoriesData } = useListDocumentCategoriesQuery();

  const [deleteDocument, { isLoading, isSuccess, isError, error }] = useDeleteDocumentMutation();
  const handleDelete = async () => {
    await deleteDocument({ documentId, versionId, orderId });
  };

  const handleClose = () => {
    if (isSuccess) {
      dispatch(getAdminDocuments(orderId, allCategories));
    }
    onClose();
  };

  return (
    <SwitchDialogWindows
      isLoading={isLoading}
      loadingTitle={'Working...'}
      isCompleted={isSuccess || isError}
      isError={isError}
      successTitle={''}
      successMessage={<DeleteSuccessMessage />}
      onRetryClick={handleDelete}
      onCloseClick={handleClose}
      errorTitle={<DeleteErrorTitle />}
      errorMessage={<DeleteErrorMessage error={error} />}
    >
      <ModalWindow uitype={'fit'} title={`Delete Document`} onClose={onClose}>
        <Grid columnCount={4} alignItems={'center'}>
          <BodyTextTW className={'col-span-4'}>Are you sure you want to delete this document?</BodyTextTW>
          <Button intent={'danger'} onClick={handleDelete} data-test-id={`confirm-delete-document`} type={'button'}>
            Delete
          </Button>
          <Button intent="ghost" isInline onClick={onClose} type={'button'}>
            Cancel
          </Button>
        </Grid>
      </ModalWindow>
    </SwitchDialogWindows>
  );
};
